import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { ApiRequestService } from './api-request.service';

@Injectable()
export class DownloadService {

  constructor (
    private httpClient:         HttpClient,
    private apiRequestService:  ApiRequestService
  ) { }

  downloadFile (url: string) {
    return this.apiRequestService.downloadFile(url);
  }

  downloadFileHeaderResponse(url: string) {
    return this.apiRequestService.downloadFileHeaderResponse(url);
  }

  downloadFilePub (url: string) : Observable<any>  {
    return this.httpClient.get(url, {
      responseType: "blob",
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map ((resposta: any) => {
        if (resposta.type === HttpEventType.DownloadProgress) {
          let percent = Math.round(resposta.loaded / resposta.total * 100);
          return {'percent': percent, 'loaded': resposta.loaded, 'total': resposta.total}
        }
        else if (resposta.type === HttpEventType.Response && (resposta.status == 200 || resposta.status == 204))
          return resposta;

      }),
      catchError (error => {
        let header = null;
        let body = null;
        return throwError({error, url, body, header, 'method': 'DOWNLOAD' });        
      }) 
    );   
  }

}
